import { render, staticRenderFns } from "./TabCobs.vue?vue&type=template&id=290d85fa&scoped=true&"
import script from "./TabCobs.vue?vue&type=script&lang=js&"
export * from "./TabCobs.vue?vue&type=script&lang=js&"
import style0 from "./TabCobs.vue?vue&type=style&index=0&id=290d85fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290d85fa",
  null
  
)

export default component.exports